import React, { useState, useEffect } from "react";
import "../../Style.css";
import Utils from "../../core/Utils";
import UserHelper from "../../core/UserHelper";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { connectToStore } from "../../data/store";
import SideBarMenuItems from "../SideBarMenuItems";
import SettingsMenuItems from "../SettingsMenuItems";
import ReportMenuItems from "../ReportMenuItems";
import FormControl from "@mui/material/FormControl";
import Button from "@mui/material/Button";
import {
  SideBarMenuNames,
  SettingsMenuList,
  ReportMaxDateLimit,
} from "../../core/Constants";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import MessagePopup from "../common/MessagePopUp";
import { Typography } from "@mui/material";
import { Grid, Box, Container, Stack, Switch } from "@mui/material";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import Loader from "../common/Loader";
import moment from "moment";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import InputLabel from "@mui/material/InputLabel";
import TextField from "@mui/material/TextField";
import { getBusiness } from "../../data/localSettingsActions";
import { postAsync } from "../../core/serviceClient";
import { UserRoles } from "../../core/Constants";
import { LoginPage, ProfitAndLossReportPage } from "../../core/PageConstants";
import CountryHelper from "../../core/CountryHelper";
import SendIcon from '@mui/icons-material/Send';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ClearIcon from '@mui/icons-material/Clear';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

const ProfitAndLossReport = (props) => {
  document.title = "Profit And Loss";
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [msgOpen, setMsgOpen] = useState(false);
  const [msgText, setMsgText] = useState("");
  const [filterByBranch, setFilterByBranch] = useState(false);
  const [selectedDate, setSelectedDate] = useState([
    Utils.GetStartDate(),
    Utils.GetEndDate(),
  ]);

  const [localSettings, setLocalSettings] = useState(connectToStore());
  const [reportContent, setReportContent] = useState("");
  const [emailId, setEmailId] = useState("");
  const [isNavigateToLogin, setIsNavigateToLogin] = useState(false);
  const [selectedBranch, setSelectedBranch] = useState("");
  const [branches, setBranches] = useState([]);

  const handleFilterByBranchChange = (event) => {
    setFilterByBranch(event.target.checked);
  };

  const handleMsgClose = () => {
    setMsgOpen(false);
    if (isNavigateToLogin) {
      UserHelper.LogOut(dispatch);
      navigate(LoginPage.Path);
    }
  };

  const onDateChange = (date) => {
    if (!Utils.IsNullOrEmptyArray(date)) {
      var dateArray = [moment(date[0]), moment(date[1])];
      if (dateArray[0]._isValid == false || dateArray[1]._isValid == false) {
        setMsgText(
          "Please select a valid date range."
        );
        setMsgOpen(true);
      }
      else {
        let dateDiff = dateArray[1].diff(dateArray[0], "days");
        if (dateDiff > ReportMaxDateLimit) {
          setMsgText(
            "Please note that the maximum date range you can select is 366 days. You can choose any start date within the past 366 days, but the end date cannot exceed this limit."
          );

          setMsgOpen(true);
        } else {
          setSelectedDate(dateArray);
        }
      }
    }
  };

  const checkAuthentication = () => {
    if (
      UserHelper.CheckPermission(
        ProfitAndLossReportPage,
        navigate,
        localSettings
      )
    ) {
      const business = getBusiness();
      if (
        !Utils.IsNullOrEmptyObject(business) &&
        !Utils.IsNullOrEmptyArray(business.branchLocations)
      ) {
        setBranches(business.branchLocations);
      }
    }
  };

  useEffect(() => {
    checkAuthentication();
  }, []);

  const handleSelect = (event) => {
    setSelectedBranch(event.target.value);
  };

  const handleSubmit = async () => {
    const branchId = selectedBranch;
    const Admin =
      localSettings.user.role === UserRoles.GlobalAdmin && !filterByBranch;
    const currentDate = Utils.GetCurrentDate();
    setIsLoading(true);
    let response = await postAsync("Reports/ProfitandLossReport", {
      BusinessId: localSettings.business.id,
      CompanyName: localSettings.business.companyName,
      EmailId: emailId,
      startDate: selectedDate[0],
      endDate: selectedDate[1],
      branchId: branchId,
      UserProfile: localSettings.user,
      IsAdmin: Admin,
      LocalDate: Utils.GetISODateTimeString(currentDate),
      IsSendEmail: true,
      Token: localSettings.token,
    });
    setIsLoading(false);
    setIsNavigateToLogin(response.isNavigateToLogin);
    if (response.error) {
      setMsgText(response.errorMessage);
      setMsgOpen(true);
      return;
    }
    setReportContent(response.data.webContent);
  };

  const handleEmailClicked = async () => {
    const branchId = selectedBranch;
    const Admin =
      localSettings.user.role === UserRoles.GlobalAdmin && !filterByBranch;
    const currentDate = Utils.GetCurrentDate();
    setIsLoading(true);
    let dateDiff = selectedDate[1].diff(selectedDate[0], "days");
    if (dateDiff >= 365) {
      setIsLoading(false);
      setMsgText("The date range should be less than or equal to 365 days.");
      setMsgOpen(true);
      return false;
    } else if (!Utils.IsEmailValid(emailId)) {
      setIsLoading(false);
      setMsgText("Please enter a valid email ID.");
      setMsgOpen(true);
      return false;
    } else {
      let response = await postAsync("Reports/ProfitandLossReport", {
        BusinessId: localSettings.business.id,
        CompanyName: localSettings.business.companyName,
        EmailId: emailId,
        startDate: selectedDate[0],
        endDate: selectedDate[1],
        branchId: branchId,
        UserProfile: localSettings.user,
        IsAdmin: Admin,
        LocalDate: Utils.GetISODateTimeString(currentDate),
        IsSendEmail: true,
        Token: localSettings.token,
      });
      setIsNavigateToLogin(response.isNavigateToLogin);
      let errorMsg = "Unable to process your request.";
      if (response.error) {
        errorMsg = response.errorMessage;
      } else if (response.data.emailSent) {
        errorMsg = "Email sent successfully.";
        setOpen(false);
      }
      setMsgText(errorMsg);
      setMsgOpen(true);
      setIsLoading(false);
    }
  };

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleLabelClear = (event) => {
    setSelectedBranch(""); // Set the value to an empty string to clear the selection
    setSelectedBranch(event.target.value);
  }

  return (
    <Container maxWidth="false" className="bg-color p-0">
      <Grid className="container">
        <Loader open={isLoading} />
        <MessagePopup
          msgOpen={msgOpen}
          msgText={msgText}
          onMsgClose={handleMsgClose}
        />
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title" sx={{ fontSize: "18px", fontWeight: "600" }}>
            {"Send profit & loss reports to your email"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Stack direction="row" justifyContent="end" spacing={1} className="font-size-14">
                <FormControl fullWidth>
                  <TextField
                    label="Email"
                    value={emailId}
                    type="email"
                    onChange={(e) => {
                      setEmailId(e.target.value);
                    }}
                  />
                </FormControl>
                <Stack
                  direction="row"
                  xs={12}
                  justifyContent="end"
                  alignSelf="center"
                >
                  <FormControl>
                    <Button
                      sx={{ height: "53px" }}
                      variant="contained"
                      className="btn btn-primary"
                      onClick={handleEmailClicked}
                      autoFocus
                    >
                      Send
                    </Button>
                  </FormControl>
                </Stack>
              </Stack>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button className="btn btn-secondary" onClick={handleClose}>
              Close
            </Button>
          </DialogActions>
        </Dialog>
        <Box>
          <Grid container m={0}>
            <SideBarMenuItems selectedTab={SideBarMenuNames.InvoiceReport} />
            <Grid xs={12} className="content-sec">
              <Grid container direction="row" className="">
                <ReportMenuItems
                  selectedMenu={SettingsMenuList.BusinessReports.ProfitAndLoss}
                />
                <Grid xs={12} md={9}>
                  <Grid spacing={2} className="form-sec">
                    <Stack
                      alignSelf="center"
                      justifyContent="space-between"
                      direction="row"
                      flex="1"
                      className="card white-bg p-1 sticky-search-form"
                    >
                      <Stack
                        direction="row"
                        spacing={2}
                        alignItems="center"
                      >
                        <FormControl
                          fullWidth
                          variant="outlined"
                          margin="dense"
                          className="font-size-14"
                          sx={{ width: "300px" }}
                        >
                          <InputLabel id="Branch-label">Filter by Branch</InputLabel>
                          <Select
                            value={selectedBranch}
                            onChange={handleSelect}
                            label="Branch Name"
                            InputLabelProps={{ shrink: true }}
                            style={{
                              height: "46px",
                            }}
                          >
                            {branches.map((branch, index) => (
                              <MenuItem key={index} value={branch.branchId}>
                                {branch.branchName}
                              </MenuItem>
                            ))}
                          </Select>
                          <Button className="clearBtn" title="Clear" onClick={handleLabelClear}><ClearIcon /></Button>
                        </FormControl>
                      </Stack>
                      <Stack
                        direction="row"
                        spacing={1}
                        style={{ height: "100%", alignItems: "center" }}
                      >
                        <DateRangePicker
                          showLeadingZeros={true}
                          onChange={onDateChange}
                          maxDate={new Date()}
                          value={selectedDate}
                          locale={CountryHelper.GetDateCulture(localSettings.country.Culture)}
                          clearIcon={null}
                          calendarIcon={
                            <CalendarMonthOutlinedIcon
                              style={{
                                "font-size": "24px",
                                "align-self": "center",
                                color: "#666666",
                              }}
                            />
                          }
                        />
                        <FormControl>
                          <Button
                            className="btn btn-secondary"
                            variant="contained"
                            onClick={handleClickOpen}
                          >
                            <SendIcon fontSize="large" /> &nbsp;
                            Send Email
                          </Button>
                        </FormControl>
                        <FormControl>
                          <Button
                            className="btn btn-secondary"
                            variant="contained"
                            onClick={handleSubmit}
                          >
                            <VisibilityIcon fontSize="large" /> &nbsp;
                            View Profit & Loss
                          </Button>
                        </FormControl>
                      </Stack>
                    </Stack>

                    <iframe
                      className="reportIframe card white-bg"
                      srcdoc={reportContent}
                      style={{
                        width: "100%",
                        height: "calc(100vh - 180px)",
                        marginTop: "7px",
                      }}
                    ></iframe>
                    <br />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Grid>
    </Container>
  );
};

export default ProfitAndLossReport;
